function imageSize(src) {
  /* eslint-disable */
  var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  /* esling-enable */

  if (match) {
    return match[1];
  } else {
    return null;
  }
}

function getSizedImageUrl(src, size) {
  if (size === null) {
    return src;
  }

  if (size === 'master') {
    return removeProtocol(src);
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + '_' + size + suffix);
  } else {
    return null;
  }
}

const createItem = ({
  product_id,
  variant_id: id,
  title,          // Shopify's own line_item.title. On a line merged by a Cart
                  // Transform Function (has_components: true), Shopify sets
                  // this to the bundle's real title already.
  product_title,  // the underlying variant's own product name (e.g. "Really
                  // Nice Tamper") — shown as the component sub-title.
  line_price: price,
  options_with_values,
  image,
  url,
  quantity,
  properties,
  components,
  line_components,
  item_components,
  has_components,
}) => {
  const variantTitle = formatVariant(options_with_values);

  let propertiesHtml = '';
  if (properties && Object.keys(properties).length > 0) {
    propertiesHtml = Object.entries(properties)
      .filter(([key, value]) => value && !key.startsWith('_'))
      .map(([key, value]) => `<div class='xxsmall sans caps cm mt025 book'>${key}: ${value}</div>`)
      .join('');
  }

  let componentsHtml = '';
  const itemComponents = line_components || components || item_components;
  if (itemComponents && itemComponents.length > 0) {
    componentsHtml = `<div class="cart-item__components mt025" style="padding-left: 1rem; border-left: 1px solid rgba(var(--color-foreground), 0.2); margin-top: 0.5rem; display: flex; flex-direction: column; gap: 0.25rem;">`;
    itemComponents.forEach(component => {
      // component.title (Shopify's own line_item.title) is ALREADY the
      // combined "Product - Variant" string (e.g. "Unibasket® - 20g") — so
      // if we use it AND separately append variant_title, the variant ends
      // up doubled ("Unibasket® - 20g - 20g x 1"). Prefer the plain product
      // title so the variant is only ever appended once; only fall back to
      // component.title (skipping the separate variant append) when no
      // plain product title field is available at all.
      const compProductTitle = component.product_title || (component.product && component.product.title) || '';
      const compVariant = component.variant_title || (component.variant && component.variant.title) || '';
      const variantText = compVariant && compVariant !== 'Default Title' ? ` - ${compVariant}` : '';
      const compQty = component.quantity ? ` x ${component.quantity}` : '';

      const compTitle = compProductTitle || component.title || '';
      const appendVariant = compProductTitle ? variantText : '';

      componentsHtml += `<div class="xxsmall sans caps cm book" style="opacity: 0.7; text-transform: uppercase;">↳ ${compTitle}${appendVariant}${compQty}</div>`;
    });
    componentsHtml += `</div>`;
  }

  // Whether this line represents a bundle, for TITLE purposes: either our
  // own _bundle property survived the add (separate line items path), or
  // Shopify's Cart Transform Function merged it (has_components: true —
  // seen in practice to NOT always carry all our _bundle* properties
  // through the merge, only _bundleHostTitle). Deliberately NOT "title !=
  // product_title" on its own — Shopify's own standard line_item.title for
  // any ordinary multi-variant product is "{product_title} - {variant
  // title}" (e.g. "Blind Shaker - Silver"), which always differs from
  // product_title too. Treating that as "this is a bundle" made a normal
  // product's title and subtitle show the exact same "Product - Variant"
  // text twice.
  const isBundleForTitle = Boolean(
    has_components ||
    (properties && properties['_bundle'] === 'true') ||
    (properties && properties['_bundleHostTitle'])
  );

  // Bundle marker. Used to show a strikethrough "was $X, now $Y" price
  // comparison via _bundle_base/_bundle_final, but those properties were
  // dropped (the only thing reading them was this display, and the real
  // charged price — already shown via `price` below — is authoritative
  // regardless) — just mark the line as a bundle now.
  const isBundle = properties && properties['_bundle'] === 'true';
  const bundlePriceHtml = isBundle
    ? `<div class="cart-item__bundle-price xxsmall sans" style="margin-top:0.3rem; opacity:0.55;">Bundle</div>`
    : '';

  const img = image
    ? getSizedImageUrl(image.replace("." + imageSize(image), ""), "200x")
    : "https://www.placecage.com/200/200"; // todo: replace with different placeholder image

  // For bundle items, show the bundle host title instead of the underlying
  // variant's own product title. Two sources, in priority order:
  //   1. Shopify's own `title` field, when has_components confirms a Cart
  //      Transform Function actually relabeled this merged line — that
  //      gate matters: title alone differing from product_title is also
  //      true for any ordinary variant product (see isBundleForTitle),
  //      so has_components is what tells a real relabel apart from that.
  //   2. The `_bundleHostTitle` hidden property, for cases where no
  //      relabeling happened at the platform level (e.g. separate line
  //      items that never got merged) but we still attached it ourselves.
  const titleWasRelabeled = Boolean(has_components && title && product_title && title !== product_title);
  const bundleHostTitle = (titleWasRelabeled && title)
    || (isBundleForTitle && properties && properties['_bundleHostTitle'])
    || null;
  const displayTitle = bundleHostTitle || product_title;
  const componentSubtitle = bundleHostTitle
    ? `<div class='xxsmall sans caps cm mt025 book' style='opacity:0.65;'>${product_title}${variantTitle ? ` — ${variantTitle}` : ''}</div>`
    : `<div class='xxsmall sans caps cm mt025 book'>${variantTitle}</div>`;

  // View this as cart-item.liquid - basically. -ae 06.22.19
  return `
    <drawer-item class='cart-drawer__item' data-component='cartDrawerItem' data-pid=${product_id} data-id=${id}>
      <a href='${url}' class="cart-drawer__item-image">
        <img src='${img}' />
      </a>

      <div class='cart-item__details f fdc jcb'>
        <div class='cart-item__header'>
          <div class='cart-item__title'>
            <a href='${url}' class='caps mv0 unstyled-link'>${displayTitle}</a>
            ${componentSubtitle}
            ${propertiesHtml}
            ${componentsHtml}
            ${bundlePriceHtml}
          </div>
          <span class='dn'>${formatMoney(price)}</span>
          <div class='cart-item__price'>${removeTrailingZeros(
    formatMoney(price)
  )}</div>
        </div>

        <div class='cart-item__tools'>
          <div class='cart-item__stepper aic f ${price === 0 ? "is-disabled" : ""
    }'>
            <div class='cart-stepper js-remove-single'>
              <span class='visually-hidden'>Decrease quantity for ${displayTitle}</span>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus cart-stepper--remove" fill="none" viewBox="0 0 10 2">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
              </svg>
            </div>
            <div class='cart-quantity js-single-quantity'>${quantity}</div>
            <div class='cart-stepper js-add-single'>
              <span class='visually-hidden'>Increase quantity for ${displayTitle}</span>
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus cart-stepper--add" fill="none" viewBox="0 0 10 10">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
              </svg>
            </div>
          </div>

          <button class='button--reset button--remove js-remove-item'>Remove</button>
        </div>
      </div>
    </drawer-item>
`;
};

function renderItems(items) {
  if (items === undefined) {
    return;
  }
  if (items.length <= 0) return '';

  const drawer = document.querySelector('cart-drawer');
  const componentsMap = drawer ? (drawer._bundleComponentsMap || new Map()) : new Map();

  return items.reduce((accum, item) => {
    const itemKey = item.key || (item.variant_id ? item.variant_id.toString() : '');
    const mappedComponents = componentsMap.get(itemKey) || [];
    return accum + createItem({ ...item, line_components: mappedComponents });
  }, '');
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartDrawerState = {
      open: false,
    };

    this.overlay = this.querySelector('.js-overlay');
    this.closeButton = this.querySelector('.js-close');
    this.subtotal = this.querySelector('.js-subtotal');
    this.currencyCode = this.querySelector('.js-currency-code');
    this.itemsRoot = this.querySelector('.js-cart-drawer-items');
    this.upsellBlock = this.querySelector('upsell-block');
    this.cartDrawer = this.querySelector('.js-cart-drawer');
    this.cartCount = document.querySelectorAll('.js-cart-count');
    this.cartBubble = document.querySelector('.js-cart-bubble');
    this.cartFooter = this.querySelector('.js-cart-footer');
    this.cartEmpty = this.querySelector('.js-cart-empty');
    this.cartEmptyMsg = this.querySelector('.js-empty-message');

    this.cartToggle = document.querySelector('.js-cart-drawer-toggle');
    this._bundleComponentsMap = new Map();
  }

  connectedCallback() {
    this.fetchBundleComponents().finally(() => {
      // Check initial cart state on load
      fetchCart().then((cart) => {
        if (cart.item_count) {
          this.cartBubble.classList.add("is-active");
        } else {
          this.cartBubble.classList.remove("is-active");
        }
      });
    });

    document.addEventListener('cart:updated', (e) => {
      e.preventDefault();

      fetchCart().then((cart) => {
        this.fetchBundleComponents().finally(() => {
          this.render(cart);

          this.cartCount.forEach((cartCountEl) => {
            cartCountEl.innerHTML = cart.item_count;
          });
          this.upsellBlock.updateUpsellItems();

          if (cart.item_count) {
            this.cartBubble.classList.add('is-active');
          } else {
            this.cartBubble.classList.remove('is-active');
          }
        });
      });
    });

    this.cartToggle.addEventListener('click', (e) => {
      e.preventDefault();
      fetchCart().then((cart) => {
        this.open(cart);
        this.setActiveElement(document.activeElement);
      });

      this.cartDrawerState.open = true;
    });

    this.overlay.addEventListener('click', (e) => {
      e.preventDefault();
      this.close();

      this.cartDrawerState.open = false;
    });

    this.closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.close();

      this.cartDrawerState.open = false;
    });
  }

  fetchBundleComponents() {
    return fetch(window.Shopify.routes.root + '?sections=cart-components')
      .then(res => res.json())
      .then(data => {
        try {
          const html = data['cart-components'] || '';
          if (!html) {
            return;
          }
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const jsonText = doc.querySelector('.shopify-section')?.textContent || doc.body.textContent || '[]';
          const list = JSON.parse(jsonText.trim() || '[]');

          this._bundleComponentsMap.clear();
          list.forEach(item => {
            // NOTE: item_components (Shopify's real Cart Transform field —
            // see sections/cart-components.liquid) is only ever non-empty
            // when a Cart Transform Function merges line items into one.
            if (item.item_components && item.item_components.length > 0) {
              this._bundleComponentsMap.set(item.id.toString(), item.item_components);
              if (item.key) {
                this._bundleComponentsMap.set(item.key, item.item_components);
              }
            }
          });
        } catch (e) {
          console.error('[cart-drawer] Failed to parse cart-components JSON:', e);
        }
      })
      .catch(err => {
        console.error('[cart-drawer] Error fetching cart-components section:', err);
      });
  }

  render = (cart) => {
    this.itemsRoot.innerHTML = renderItems(cart.items);
    // this is using es2020 nullish coalescing operator and may cause issues on older browsers - ae05.30.22
    this.subtotal.innerHTML = removeTrailingZeros(
      formatMoney(cart.total_price)
    );
    this.currencyCode.innerHTML =
      document.querySelector("meta[property='currency-code']")?.content ?? "";

    if (cart.items === undefined) {
      this.cartFooter.classList.add("is-hidden");
      this.itemsRoot.classList.add("is-hidden");
      this.cartEmpty.classList.remove("is-hidden");
      this.cartEmptyMsg.classList.add("is-hidden");
    } else if (cart.items.length === 0) {
      // hide items mount point and cart footer if there are no items in the cart
      this.cartFooter.classList.add("is-hidden");
      this.itemsRoot.classList.add("is-hidden");
      this.cartEmpty.classList.remove("is-hidden");
    } else {
      // unhide items mount point and cart footer if there are items in the cart
      this.cartFooter.classList.remove("is-hidden");
      this.itemsRoot.classList.remove("is-hidden");
      this.cartEmpty.classList.add("is-hidden");
    }
  };

  open = (cart) => {
    if (cart === undefined) {
      const err = `Open requires a Cart object to be passed, cart is currently set to ${cart}`;
      throw new Error(err);
    }

    try {
      hideChatWidget();
    } catch (e) {
      // chat widget not present on this page — nothing to hide
    }

    this.classList.remove('is-hidden');
    this.classList.add('is-active');

    this.itemsRoot.innerHTML = this.loading;

    this.fetchBundleComponents().finally(() => {
      setTimeout(() => {
        this.classList.add('is-visible');
        this.tabIndex = 0;
        this.cartDrawer.tabIndex = 0;
        this.setAttribute('aria-expanded', 'true');
        document.getElementById('root').tabIndex = -1;
        setTimeout(this.render(cart), 10);
        this.cartDrawerState.open = true;
        // this.upsellBlock?.updateSlider();
      }, 50);
    });
  };

  close = () => {
    this.classList.remove('is-visible');

    try {
      showChatWidget();
    } catch (e) {
      // chat widget not present on this page — nothing to show
    }

    document.getElementById('root').tabIndex = 0;

    setTimeout(() => {
      this.classList.remove('is-active');
      this.classList.add('is-hidden');
      this.tabIndex = -1;
      this.setAttribute('aria-expanded', 'false');
      this.cartDrawerState.open = false;
    }, 400);
  };

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class DrawerItem extends HTMLElement {
  constructor() {
    super();

    this.removeButton = this.querySelector('.js-remove-item');
    this.decrease = this.querySelector('.js-remove-single');
    this.increase = this.querySelector('.js-add-single');
    this.currentQty = this.querySelector('.js-single-quantity').innerHTML;
    this.id = this.getAttribute('data-id');
  }

  connectedCallback() {
    this.removeButton.addEventListener('click', (e) => {
      e.preventDefault();
      removeAddon(this.id);
    });

    this.decrease.addEventListener('click', (e) => {
      e.preventDefault();
      updateAddon(this.id, parseInt(this.currentQty) - 1);
    });

    this.increase.addEventListener('click', (e) => {
      e.preventDefault();
      updateAddon(this.id, parseInt(this.currentQty) + 1);
    });
  }
}

customElements.define('drawer-item', DrawerItem);

class UpsellBlock extends HTMLElement {
  constructor() {
    super();
    this.upsellItemsContainer = this.querySelector('.upsell-products-container');
    this.discountableUpsellCards = null;
    this.loadingSpinnerSnippet = `
      <div class="loading-overlay--upsell" style="display: flex; justify-content: center; align-items: center; min-height: 100px;">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" style="width: 30px; height: 30px;" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" stroke="currentColor" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;
  }

  connectedCallback() {
    this.updateUpsellItems();
  }

  updateUpsellItems() {
    if (this.upsellItemsContainer) {
      this.upsellItemsContainer.innerHTML = this.loadingSpinnerSnippet; // Show loader
    }

    fetch('/cart?view=upsell-items')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const updatedHTML = parser.parseFromString(html, 'text/html');
        const upsellData = updatedHTML.querySelector('.cart-upsell-block').innerHTML;
        this.renderUpsellItems(upsellData);
        this.updateDiscountableUpsellPrices(this.discountableUpsellCards);
      })
      .catch(error => {
        console.error('Error fetching upsell items:', error);
      });
  }

  renderUpsellItems(html) {
    if (this.upsellItemsContainer) {
      this.upsellItemsContainer.innerHTML = html;
      this.discountableUpsellCards = this.upsellItemsContainer.querySelectorAll('product-card-small[data-upsell-discount-product="true"]');
    }
  }

  updateSlider() {
    // Delay execution slightly to ensure it's visible & rendered
    setTimeout(() => {
      const upsellProductsEl = this.querySelector('upsell-products');
      if (upsellProductsEl && typeof upsellProductsEl.thumbnailSlider?.update === 'function') {
        upsellProductsEl.thumbnailSlider.update(); // Re-initialize Keen if already mounted
      } else if (upsellProductsEl && !upsellProductsEl.thumbnailSlider) {
        // Manually trigger connectedCallback again if necessary
        upsellProductsEl.connectedCallback?.();
      }
    }, 100); // Adjust timeout as needed
  }

  updateDiscountableUpsellPrices() {
    if (!this.discountableUpsellCards || this.discountableUpsellCards.length === 0) {
      return;
    }

    this.discountableUpsellCards.forEach(cardElement => {
      const priceContainer = cardElement.querySelector('.upsell-burr-price');
      if (!priceContainer) return;

      const originalLocalizedPriceCents = parseInt(priceContainer.dataset.originalLocalizedPriceCents, 10);
      // This is the discount in USD_CENTS (e.g., 10000 for $100, 15000 for $150)
      const activeUsdDiscountInUsdCents = parseInt(priceContainer.dataset.activeUsdDiscountCents, 10);

      const originalPriceDisplayEl = priceContainer.querySelector('.original-price-display');
      const discountedPriceDisplayEl = priceContainer.querySelector('.discounted-price-display');
      const discountMessageEl = priceContainer.nextElementSibling; // Assuming it's the direct next sibling

      const moneyFormat = window.moneyFormat || "{{amount}}"; // From theme.liquid
      const shopifyCurrencyRate = parseFloat(Shopify.currency.rate); // Rate: Primary Shop Currency to Current Display Currency

      if (isNaN(originalLocalizedPriceCents) || isNaN(activeUsdDiscountInUsdCents)) {
        originalPriceDisplayEl.style.display = 'none';
        discountedPriceDisplayEl.innerHTML = customFormatMoney(originalLocalizedPriceCents || 0, moneyFormat);
        if (discountMessageEl && discountMessageEl.classList.contains('discount-message')) discountMessageEl.style.display = 'none';
        return;
      }

      if (activeUsdDiscountInUsdCents > 0 && !isNaN(shopifyCurrencyRate) && shopifyCurrencyRate > 0) {

        const localizedDiscountAmountCents = Math.round((activeUsdDiscountInUsdCents / 100) * shopifyCurrencyRate * 100);

        const calculatedDiscountedLocalizedPriceCents = originalLocalizedPriceCents - localizedDiscountAmountCents;

        // Ensure discounted price is not negative
        const finalDisplayPriceCents = Math.max(0, calculatedDiscountedLocalizedPriceCents);

        originalPriceDisplayEl.innerHTML = `<s>${customFormatMoney(originalLocalizedPriceCents, moneyFormat)}</s>`;
        discountedPriceDisplayEl.innerHTML = customFormatMoney(finalDisplayPriceCents, moneyFormat);
        originalPriceDisplayEl.style.display = 'inline';

        if (discountMessageEl && discountMessageEl.classList.contains('discount-message')) {
          discountMessageEl.style.display = 'block';
        }

      } else {
        originalPriceDisplayEl.style.display = 'none';
        discountedPriceDisplayEl.innerHTML = customFormatMoney(originalLocalizedPriceCents, moneyFormat);
        if (discountMessageEl && discountMessageEl.classList.contains('discount-message')) {
          discountMessageEl.style.display = 'none';
        }
      }
    });
  }

}

customElements.define('upsell-block', UpsellBlock);
